import module from 'module';
import templateUrl from './tooltip.template.html';
import './tooltip.component.less';

class Tooltip {
  constructor() {}
}

module.component('tooltip', {
  templateUrl,
  transclude: {
    'wrapper': 'tooltipWrappedElement',
    'body': 'tooltipBody'
  },
  controller: Tooltip
});